import { makeMessages, makeTranslation } from 'utils'

const messages = {
  browse: 'browse',
  seePromo: { id: 'promoProduct.seePromotion' },
}

export default makeMessages(messages, makeTranslation('promoGroup.tile'))
